<template>
    <section class="container is-hidden-mobile">
        <div class="flex justify-around items-center flex-wrap mx-4 my-4">
            <div class="w-1/8 text-center" v-for="partner in partners">
                <a :href="partner.url[currentLanguage]"><img :src="'/static/partners/' + partner.id + '-square.png'" alt=""></a>
            </div>
        </div>
    </section>
</template>
<script>
    import helpers from '@/mixins/helpers'

    export default {
        mixins: [helpers],

        data () {
            return {
                partners: [
                    {
                        id: 'smd',
                        url: {
                            fr: 'https://www.dentiste.be',
                            nl: 'https://www.dentiste.be',
                            en: 'https://www.dentiste.be',
                        }
                    },
                    {
                        id: 'partena_mut',
                        url: {
                            fr: 'https://www.partenamut.be',
                            nl: 'https://www.partena-ziekenfonds.be',
                            en: 'https://www.partenamut.be',
                        }
                    },
                    {
                        id: 'banque_van_breda',
                        url: {
                            fr: 'https://www.banquevanbreda.be',
                            nl: 'https://www.bankvanbreda.be',
                            en: 'https://www.banquevanbreda.be',
                        }
                    },
                    {
                        id: 'amonis',
                        url: {
                            fr: 'http://www.amonis.be/fr',
                            nl: 'http://www.amonis.be/nl',
                            en: 'http://www.amonis.be/fr',
                        }
                    },
                    {
                        id: 'dental_addict',
                        url: {
                            fr: 'https://www.dental-addict.be/fr',
                            nl: 'https://www.dental-addict.be/nl',
                            en: 'https://www.dental-addict.be/fr',
                        }
                    },
                    {
                        id: 'apb',
                        url: {
                            fr: 'https://www.apb.be/fr',
                            nl: 'https://www.apb.be/nl',
                            en: 'https://www.apb.be/fr',
                        }
                    },
                ]
            }
        },

        computed: {
            currentLanguage () {
                if (this.doctor) {
                    return this.doctor.language.substring(0,2) || 'en'
                }

                return 'en'
            }
        }
    }
</script>
<style lang="scss">
    .flex {
        display: flex;
    }

    .justify-around {
        justify-content: space-around;
    }

    .justify-between {
        justify-content: space-between;
    }

    .justify-center {
        justify-content: center;
    }

    .items-center {
        align-items: center;
    }

    .w-1\/7 {
        width: calc(100% / 7);
    }

    .w-1\/8 {
        width: calc(100% / 8);
    }
</style>



// WEBPACK FOOTER //
// src/components/Doctor/PartnersList.vue